import type { PoiKind } from "../types";

// ─── Domain types ─────────────────────────────────────────────────────────────

export interface DetourInfo {
  arrivalS:    number;
  detourCostS: number;
  reachable:   boolean;
}

export interface ParsedPoi {
  id:         string;
  osmType:    "node" | "way";
  lat:        number;
  lng:        number;
  name:       string;
  amenity:    string;
  tags:       Record<string, string>;
  kind:       PoiKind;
  routeDistM: number;
  detour?:    DetourInfo;
  /** Live-mode ETA override (seconds from departure). Set by index.ts on each GPS fix. */
  liveEtaS?:  number;
  /** Live-mode: true once the vehicle has passed this POI on the route. */
  liveMissed?: boolean;
}

// ─── Colour helpers ───────────────────────────────────────────────────────────

export function getPoiColorClass(poi: ParsedPoi): string {
  if (!poi.detour?.reachable) return "poi-color-grey";
  const mins = poi.detour.detourCostS / 60;
  if (mins <= 5)  return "poi-color-green";
  if (mins <= 15) return "poi-color-yellow";
  return "poi-color-red";
}

export const KIND_FILL: Record<PoiKind, string> = {
  mcd:    "#fbbf24",
  orlen:  "#ef4444",
  toilet: "#1d4ed8",
  other:  "#3b82f6",
};

export const KIND_BORDER: Record<PoiKind, string> = {
  mcd:    "#eab308",
  orlen:  "#ef4444",
  toilet: "#000080",
  other:  "#ffffff",
};

// ─── Duration formatting ───────────────────────────────────────────────────────

export function formatDuration(seconds: number): string {
  if (seconds < 0) return "—";
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const hrs = Math.floor(mins / 60);
  const rem = mins % 60;
  return rem > 0 ? `${hrs}h ${rem}min` : `${hrs}h`;
}
